
export class PaymentDetail{
   status: string = ""
   currency: string = ""
    amount: number = 0.0
    paymentType:string=""
    phone:string=""

}
